export const convertBase64ToSvg = (base64String: string, color: string) => {
  if (base64String.includes("data:image/svg+xml;base64,")) {
    const svgContent = atob(
      base64String.replace("data:image/svg+xml;base64,", "")
    );
    const updatedSvgContent = svgContent.replace(
      /fill="([^"]*)"/g,
      `fill="${color}"`
    );
    return `data:image/svg+xml;base64,${btoa(updatedSvgContent)}`;
  } else {
    console.log("no svg");
  }
};
